<stx-generic-page>
  <stx-report-header>
    {{ 'reports.orthodontic_treatments_compact' | translate }}
  </stx-report-header>
  <stx-report-filters [reportConfig]="reportConfig" (applyFilters)="applyFilters($event)"></stx-report-filters>
  @if (reportService.initialized$ | async) {
  <stx-orthodontic-treatment-compact-report-table
    [reportConfig]="reportService.model"
    [deIdentified]="deIdentified"
    [showQaOnly]="showQaOnlySection"
    [showPagination]="showPagination"
  ></stx-orthodontic-treatment-compact-report-table>
  }
</stx-generic-page>
